<div class="content-wrapper container-xxl p-0 anmar-dashboard">
  <div class="content-body">
    <section id="anmar-resource-form">
      <div class="card">
        <div class="card-header d-flex flex-wrap justify-content-between align-items-center gap-1">
          <div>
            <h4 class="card-title mb-50">{{ (isEditMode ? 'ANMAR_PAGES.COMMON.EDIT' : 'ANMAR_PAGES.COMMON.ADD') | translate }} {{ getModuleTranslateKey() | translate }}</h4>
            <p class="card-text mb-0">{{ (isEditMode ? 'ANMAR_PAGES.COMMON.UPDATE_ENTRY' : 'ANMAR_PAGES.COMMON.CREATE_ENTRY') | translate }}</p>
          </div>
        </div>
      </div>

      <div class="card">
        <div class="card-body">
          <div *ngIf="loading" class="anmar-loading-wrap anmar-loading-form mb-2">
            <div class="anmar-loading-card anmar-loading-card-form">
              <div class="anmar-loading-brand">
                <img src="assets/images/logo/shap.png" alt="Anmar" class="anmar-loading-logo" />
                <div>
                  <div class="anmar-loading-line short"></div>
                  <div class="anmar-loading-line tiny"></div>
                </div>
              </div>
              <div class="row mt-2">
                <div class="col-md-6 mb-1" *ngFor="let skeleton of [1,2,3,4,5,6]">
                  <div class="anmar-loading-line tiny mb-50"></div>
                  <div class="anmar-loading-input"></div>
                </div>
              </div>
            </div>
            <p class="anmar-loading-text mb-0">{{ 'ANMAR_PAGES.COMMON.LOADING' | translate }}</p>
          </div>

          <div *ngIf="!loading && errorMessage" class="alert alert-danger mb-2">
            {{ errorMessage }}
          </div>

          <form *ngIf="!loading" [formGroup]="form" (ngSubmit)="submit()" novalidate>
            <div class="row">
              <div class="col-md-6" *ngFor="let field of getStandardFields()">
                <div class="form-group" [ngClass]="{ 'anmar-checkbox-group': field.type === 'checkbox' }">
                  <label *ngIf="field.type !== 'checkbox'" [for]="field.name">
                    {{ getFieldTranslateKey(field.name) | translate }}
                    <span class="text-danger" *ngIf="field.required">*</span>
                  </label>

                  <ng-container *ngIf="isImageField(field); else standardInputTemplate">
                    <input [id]="field.name" type="file" accept="image/*" class="form-control" (change)="onFileSelected($event, field.name)" />
                    <div *ngIf="getImagePreview(field.name)" class="mt-1">
                      <img [src]="getImagePreview(field.name)" [alt]="getFieldTranslateKey(field.name) | translate" class="anmar-thumb" />
                    </div>
                  </ng-container>

                  <ng-template #standardInputTemplate>
                    <input *ngIf="field.type === 'text' || field.type === 'number' || field.type === 'date'" [id]="field.name" [type]="getInputType(field)" class="form-control" [formControlName]="field.name" [readonly]="field.readonly" [placeholder]="getFieldPlaceholder(field)" />
                  </ng-template>

                  <textarea *ngIf="field.type === 'textarea' || field.type === 'array-text'" [id]="field.name" class="form-control" rows="4" [formControlName]="field.name" [readOnly]="field.readonly" [placeholder]="getFieldTranslateKey(field.name) | translate"></textarea>

                  <select *ngIf="field.type === 'select'" [id]="field.name" class="form-control" [formControlName]="field.name">
                    <option value="">{{ getFieldTranslateKey(field.name) | translate }}</option>
                    <option *ngFor="let option of normalizeOptions(field)" [ngValue]="option.value">{{ option.label }}</option>
                  </select>

                  <div *ngIf="field.type === 'checkbox'" class="custom-control custom-switch custom-switch-primary mt-2">
                    <input type="checkbox" class="custom-control-input" [id]="field.name" [formControlName]="field.name" />
                    <label class="custom-control-label" [for]="field.name">{{ getFieldTranslateKey(field.name) | translate }}</label>
                  </div>

                  <small *ngIf="field.type === 'array-text'" class="form-text text-muted">{{ 'ANMAR_PAGES.COMMON.ARRAY_HINT' | translate }}</small>

                  <div *ngIf="isInvalid(field.name)" class="invalid-feedback d-block">{{ 'ANMAR_PAGES.COMMON.REQUIRED_FIELD' | translate }}</div>
                </div>
              </div>
            </div>

            <div class="anmar-steps-section mt-2" formArrayName="steps">
              <div class="d-flex flex-wrap justify-content-between align-items-center gap-1 mb-1">
                <div>
                  <h5 class="mb-25">{{ 'ANMAR_PAGES.FIELDS.STEPS' | translate }}</h5>
                  <small class="text-muted">{{ 'ANMAR_PAGES.FIELDS.STEPS_HELP' | translate }}</small>
                </div>
                <button type="button" class="btn btn-outline-primary btn-sm" (click)="addStep()">
                  {{ 'ANMAR_PAGES.FIELDS.ADD_STEP' | translate }}
                </button>
              </div>

              <div *ngIf="!stepsControls.length" class="anmar-state text-center py-2 px-1">
                {{ 'ANMAR_PAGES.FIELDS.STEPS' | translate }}: -
              </div>

              <div class="anmar-step-card card mb-1" *ngFor="let stepGroup of stepsControls; let i = index" [formGroupName]="i">
                <div class="card-body">
                  <div class="d-flex flex-wrap justify-content-between align-items-center gap-1 mb-1">
                    <h6 class="mb-0">{{ 'ANMAR_PAGES.FIELDS.STEP' | translate }} #{{ i + 1 }}</h6>
                    <button type="button" class="btn btn-outline-danger btn-sm" (click)="removeStep(i)">
                      {{ 'ANMAR_PAGES.FIELDS.REMOVE_STEP' | translate }}
                    </button>
                  </div>

                  <div class="row">
                    <div class="col-md-2">
                      <div class="form-group">
                        <label>{{ 'ANMAR_PAGES.FIELDS.STEP_NUMBER' | translate }}</label>
                        <input type="number" class="form-control" formControlName="step_number" min="0" />
                        <div *ngIf="isStepInvalid(i, 'step_number')" class="invalid-feedback d-block">{{ 'ANMAR_PAGES.COMMON.REQUIRED_FIELD' | translate }}</div>
                      </div>
                    </div>

                    <div class="col-md-5">
                      <div class="form-group">
                        <label>{{ 'ANMAR_PAGES.FIELDS.STEP_TITLE_AR' | translate }}</label>
                        <input type="text" class="form-control" formControlName="title_ar" />
                        <div *ngIf="isStepInvalid(i, 'title_ar')" class="invalid-feedback d-block">{{ 'ANMAR_PAGES.COMMON.REQUIRED_FIELD' | translate }}</div>
                      </div>
                    </div>

                    <div class="col-md-5">
                      <div class="form-group">
                        <label>{{ 'ANMAR_PAGES.FIELDS.STEP_TITLE_EN' | translate }}</label>
                        <input type="text" class="form-control" formControlName="title_en" />
                        <div *ngIf="isStepInvalid(i, 'title_en')" class="invalid-feedback d-block">{{ 'ANMAR_PAGES.COMMON.REQUIRED_FIELD' | translate }}</div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group mb-md-0">
                        <label>{{ 'ANMAR_PAGES.FIELDS.STEP_DESCRIPTION_AR' | translate }}</label>
                        <textarea class="form-control" rows="3" formControlName="description_ar"></textarea>
                        <div *ngIf="isStepInvalid(i, 'description_ar')" class="invalid-feedback d-block">{{ 'ANMAR_PAGES.COMMON.REQUIRED_FIELD' | translate }}</div>
                      </div>
                    </div>

                    <div class="col-md-6">
                      <div class="form-group mb-0">
                        <label>{{ 'ANMAR_PAGES.FIELDS.STEP_DESCRIPTION_EN' | translate }}</label>
                        <textarea class="form-control" rows="3" formControlName="description_en"></textarea>
                        <div *ngIf="isStepInvalid(i, 'description_en')" class="invalid-feedback d-block">{{ 'ANMAR_PAGES.COMMON.REQUIRED_FIELD' | translate }}</div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="d-flex flex-wrap justify-content-end mt-2">
              <button type="button" class="btn btn-outline-primary mr-1" (click)="cancel()">{{ 'ANMAR_PAGES.COMMON.CANCEL' | translate }}</button>
              <button type="submit" class="btn btn-primary" [disabled]="submitting">
                <span *ngIf="submitting" class="spinner-border spinner-border-sm mr-50"></span>
                {{ (isEditMode ? 'ANMAR_PAGES.COMMON.UPDATE' : 'ANMAR_PAGES.COMMON.SAVE') | translate }}
              </button>
            </div>
          </form>
        </div>
      </div>
    </section>
  </div>
</div>
